import { gql } from 'graphql-tag';

export const GET_EXPENSE_ACCOUNTS = gql`
  query Idce15a936fe75d716f44a6a3acc1c2fe7(
    $companyId: ID!
    $filter: ExpenseAccountFilter
  ) {
    __typename
  }
`;
